// extracted by mini-css-extract-plugin
export default {"dashboard":"DashboardView_dashboard__G7gEL"};